import type { TextWrap } from '@/api/types/stowed-element'
import { WRAP_STYLE_TO_BACKEND } from '@/lib/object-effects/text-wrap'
import { WrapCarrier } from '../types/wrap-carrier'

/** Shared by every wrap-eligible shape/text-box build function — `wrapStyle` and the four
 *  directional offsets all live on the same `TextWrap` wire object. Offsets are only meaningful
 *  once a real wrap style is set. */
export function buildTextWrap(
  carrier: WrapCarrier
): { textWrap: TextWrap } | Record<string, never> {
  if (!carrier.wrapStyle || carrier.wrapStyle === 'none') return {}

  return {
    textWrap: {
      wrapStyle: WRAP_STYLE_TO_BACKEND[carrier.wrapStyle],
      ...(carrier.wrapOffsetTop !== undefined ? { wrapOffsetTop: carrier.wrapOffsetTop } : {}),
      ...(carrier.wrapOffsetRight !== undefined
        ? { wrapOffsetRight: carrier.wrapOffsetRight }
        : {}),
      ...(carrier.wrapOffsetBottom !== undefined
        ? { wrapOffsetBottom: carrier.wrapOffsetBottom }
        : {}),
      ...(carrier.wrapOffsetLeft !== undefined ? { wrapOffsetLeft: carrier.wrapOffsetLeft } : {}),
    },
  }
}
